import Planboard from './Planboard.vue'

export default [
  {
    path: '/planboard/exclusive/:resourceGroupKey/:selectedDate',
    component: Planboard,
    name: 'Planboard',
    props: true,
    meta: {
      title: 'Planboard',
    },
  },
]
